<main class="content-container">
  <div class="container">
    <div class="logout-container">
      <i class="app-icon-logout icon" (click)="logout()"></i>
    </div>
    <img class="logo" src="assets/imgs/logo.svg" alt="Mercadona colored logo" />
    <app-title-section [text]="('HELLO' | translate) + ', ' + username"></app-title-section>
  </div>
  <div class="grid-fixed content-grid">
    <div class="row">
      <div class="col-4" *ngFor="let cardData of exworkersCards; trackBy: trackByItems">
        <app-icon-title-card [data]="cardData" (click)="onCardClick(cardData)"></app-icon-title-card>
      </div>
    </div>
  </div>
</main>
